import { Fragment } from "react";

interface Props {
  text: string;
  keyPrefix?: string;
}
const MultiLineText = ({ text, keyPrefix }: Props) => {
  return (
    <Fragment>
      {text.split("\n").map((line, i) => (
        <span key={`${keyPrefix ?? "line"}-${i}`}>
          {line}
          <br />
        </span>
      ))}
    </Fragment>
  );
};
export default MultiLineText;
